module.exports = __webpack_public_path__ + "static/media/approve-buy.1a86d152.png";